// 모바일 웹 결제는 PG 리다이렉트로 SPA가 통째로 다시 뜨기 때문에,
// 결제 시작 정보를 sessionStorage에 보관했다가 복귀 시 결제 확인과 전환 추적에 사용한다.
const PENDING_WEB_PAYMENT_KEY = "lawlow.pendingWebPayment";

// PG 리다이렉트 복귀 시 URL에 붙는 포트원(아임포트) 결과 파라미터
const REDIRECT_PARAM_KEYS = [
  "imp_uid",
  "merchant_uid",
  "imp_success",
  "error_code",
  "error_msg",
];

// 결제를 시작한 화면 그대로 돌아오기 위한 m_redirect_url 값
export const buildPaymentReturnUrl = () =>
  `${window.location.origin}${window.location.pathname}${window.location.search}`;

export const savePendingWebPayment = (payment) => {
  try {
    sessionStorage.setItem(
      PENDING_WEB_PAYMENT_KEY,
      JSON.stringify({ ...payment, savedAt: Date.now() })
    );
  } catch (error) {
    console.error("결제 시작 정보 저장 실패:", error);
  }
};

export const loadPendingWebPayment = () => {
  try {
    const raw = sessionStorage.getItem(PENDING_WEB_PAYMENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("결제 시작 정보 조회 실패:", error);
    return null;
  }
};

export const clearPendingWebPayment = () => {
  try {
    sessionStorage.removeItem(PENDING_WEB_PAYMENT_KEY);
  } catch (error) {
    console.error("결제 시작 정보 삭제 실패:", error);
  }
};

// 리다이렉트 결과 파라미터가 없으면 null을 반환한다.
export const parsePaymentRedirectResult = (search) => {
  const params = new URLSearchParams(search);
  if (!params.has("imp_uid") && !params.has("imp_success")) {
    return null;
  }
  return {
    impUid: params.get("imp_uid"),
    merchantUid: params.get("merchant_uid"),
    isSuccess: params.get("imp_success") === "true",
    errorMsg: params.get("error_msg"),
  };
};

// 결제 결과 파라미터만 제거한 search 문자열을 반환한다.
export const stripPaymentRedirectParams = (search) => {
  const params = new URLSearchParams(search);
  REDIRECT_PARAM_KEYS.forEach((key) => params.delete(key));
  const remaining = params.toString();
  return remaining ? `?${remaining}` : "";
};
